export default {
  data () {
    return {
      guidedTourName: null,
      guidedTourRoutePath: null
    }
  },

  computed: {
    showGuideTour () {
      if (!this.guidedTourName) return false
      if (!this.$breakpoint.lgAndUp) return false

      if (this.guidedTourRoutePath) {
        const matchesRoute = this.$route.path.includes(this.guidedTourRoutePath)
        if (!matchesRoute) return false
      }

      return this.isTourVisible(this.guidedTourName)
    }
  },

  methods: {
    isTourVisible (tourName) {
      const hasDialogQuery = !!this.$route.query.dialog
      const hasQuickTourQuery = this.$route.query.openQuickTour === 'true'
      const hasUpgradeModalQuery = this.$route.query.upgradeModalOpen === 'true'
      const tourNotCompleted = !this.$store.state.guidedTours[tourName]

      return !hasDialogQuery && !hasQuickTourQuery && !hasUpgradeModalQuery && tourNotCompleted
    },

    completeTour (tourName) {
      this.$store.commit('guidedTours/setCompleted', tourName)
    },

    onTourComplete () {
      if (this.guidedTourName) {
        this.completeTour(this.guidedTourName)
      }
    }
  }
}
